import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ResearchKeywordState } from './research-keyword.reducer';

export const selectResearchKeywordState = createFeatureSelector<ResearchKeywordState>('researchKeywords');

export const selectKeywordsByProjectId = (projectId: number) =>
  createSelector(selectResearchKeywordState, (state) =>
    state.keywordsByProject[projectId] || []
  );

export const selectAllProjectsWithKeywords = createSelector(
  selectResearchKeywordState,
  (state) => Object.keys(state.keywordsByProject)
);

export const selectSelectedResearchKeyword = createSelector(
  selectResearchKeywordState,
  (state) => state.selectedKeyword
);

export const selectLoading = createSelector(
  selectResearchKeywordState,
  (state) => state.loading
);

export const selectGenerateLoading = createSelector(
  selectResearchKeywordState,
  (state) => state.generateLoading
);

export const selectError = createSelector(
  selectResearchKeywordState,
  (state) => state.error
);
